import React from 'react';

import { Form } from 'semantic-ui-react';

interface PagoTarjetaProps {
    tipoDeTarjeta: 'debito' | 'credito';
    tipoDeTarjetaDeCredito: 'visa' | 'mastercard' | 'americanexpress';
    numeroDeCuotasCredito?: number;
    idInstitucionTarjeta?: string;
    alCambiarCampo(nombreDelCampo: string, valor: string | boolean): void;
}
// TODO: instituciones agregadas a mano. Hay que sacarlas del mismo lado de matriculas
// TODO: exigir que estén todos los datos de la tarjeta para poder ingresar pago

interface State {
    creditoDeshabilitado: boolean;
}
class PagoTarjeta extends React.Component<PagoTarjetaProps, State> {
    public state: State = {
        creditoDeshabilitado: true,
    };

    public cambiarCreditoHabilitado(valor: 'credito' | 'debito') {
        if (valor === 'credito') {
            this.setState({ creditoDeshabilitado: false });
        } else if (valor === 'debito') {
            this.setState({ creditoDeshabilitado: true });
        }
    }

    public render() {
        const {
            tipoDeTarjeta,
            tipoDeTarjetaDeCredito,
            numeroDeCuotasCredito,
            idInstitucionTarjeta,
            alCambiarCampo,
        } = this.props;

        const { creditoDeshabilitado } = this.state;

        return (
            <div>
                <Form.Select
                    width={6}
                    label='Tipo de tarjeta'
                    placeholder='Seleccione'
                    required
                    value={tipoDeTarjeta}
                    options={[
                        { value: 'debito', text: 'Débito' },
                        { value: 'credito', text: 'Crédito' },
                    ]}
                    onChange={(_e, { value }) => {
                        alCambiarCampo('tipoDeTarjeta', value as string);
                        this.cambiarCreditoHabilitado(value as 'credito' | 'debito');
                    }}
                />
                <Form.Select
                    disabled={creditoDeshabilitado}
                    label='Tipo de tarjeta de crédito'
                    placeholder='Seleccione'
                    required
                    value={tipoDeTarjetaDeCredito}
                    width={6}
                    options={[
                        { value: 'visa', text: 'VISA' },
                        { value: 'mastercard', text: 'MasterCard' },
                        { value: 'americanexpress', text: 'American Express' },
                    ]}
                    onChange={(_e, { value }) => {
                        alCambiarCampo('tipoDeTarjetaDeCredito', value as string);
                    }}
                />
                <Form.Input
                    disabled={creditoDeshabilitado}
                    label='Nº de cuotas'
                    type='number'
                    min='1'
                    placeholder='3'
                    required
                    value={numeroDeCuotasCredito}
                    width={2}
                    onChange={(_e, { value }) => {
                        alCambiarCampo('numeroDeCuotasCredito', value);
                    }}
                />
                <Form.Select
                    label='Institución'
                    placeholder='Seleccione'
                    value={idInstitucionTarjeta}
                    width={6}
                    options={[
                        { value: '', text: 'No especificado' },
                        { value: 'bbva', text: 'BANCO BBVA' },
                        { value: 'bci', text: 'BANCO BCI-TBANK-NOVA' },
                        { value: 'bice', text: 'BANCO BICE' },
                        { value: 'btg', text: 'BANCO BTG PACTUAL CHILE' },
                        { value: 'consorcio', text: 'BANCO CONSORCIO' },
                        { value: 'corpbanca', text: 'BANCO CORPBANCA' },
                        { value: 'edwards', text: 'BANCO DE CHILE/EDWARDS CITYBANK' },
                        { value: 'estado', text: 'BANCO ESTADO' },
                        { value: 'falabella', text: 'BANCO FALABELLA' },
                        { value: 'hsbc', text: 'BANCO HSBC BANK CHILE' },
                        { value: 'itau', text: 'BANCO ITAU' },
                        { value: 'internacional', text: 'BANCO INTERNACIONAL' },
                        { value: 'paris', text: 'BANCO PARIS' },
                        { value: 'penta', text: 'BANCO PENTA' },
                        { value: 'rabobank', text: 'BANCO RABOBANK CHILE (EX HNS BANCO)' },
                        { value: 'bancoripley', text: 'BANCO RIPLEY' },
                        { value: 'santander', text: 'BANCO SANTANDER BANEFE' },
                        { value: 'scotiabank', text: 'BANCO SCOTIABANK/DESARROLLO' },
                        { value: 'security', text: 'BANCO SECURITY' },
                        { value: 'coopeuch', text: 'COOPEUCH' },
                        { value: 'cencosud', text: 'CENCOSUD' },
                        { value: 'cmr', text: 'CMR FALABELLA' },
                        { value: 'lider', text: 'LIDER' },
                        { value: 'ripley', text: 'RIPLEY' },
                        { value: 'smu', text: 'SMU' },
                        { value: 'tricot', text: 'TRICOT' },
                    ]}
                    onChange={(_e, { value }) => {
                        alCambiarCampo('idInstitucionTarjeta', value as string);
                    }}
                />
            </div>
        );
    }
}

export default PagoTarjeta;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/PagoTarjeta.tsx